import {ListObjectsV2Command, S3Client} from "@aws-sdk/client-s3";
import {getMimeTypeFromExtension} from "../../../utility/url";
import {Files, Folders, IContentData, IFileSystemContent} from "./FileSystemContent";

export interface IS3ReadWrite {
    key: string
    secret: string
}

export class AWSContent implements IFileSystemContent {
    private files: Files = {}
    private folders: Folders = {}

    constructor(private secret: IS3ReadWrite, private root: string) {}

    getBlockNameKey(blockName: string, format?: string) {
        const root = `${this.root}/${format?.replace(/^\/|\/$/gm, "")}/videos`;

        if (blockName.includes("/")) {
            return `${root}/${blockName}.mp4`;
        } else if (blockName.match(/^e\d\d_s\d\d\d/) ) {
            return `${root}/${blockName.split("_").slice(0, 2).join("/")}/${blockName}.mp4`;
        } else {
            return `${root}/${blockName.split("_").slice(0, 1).join("/")}/${blockName}.mp4`;
        }
    }
    getFileKeys() {
        return Object.keys(this.files);
    }
    getFile(key: string) {
        return this.files[key];
    }
    getFolder(key: string) {
        return this.folders[key];
    }
    getPath(key: string) {
        let prefix = "";

        return key.split("/").map(folder => {
            const joined = prefix + folder;

            prefix = joined + "/";
            return joined;
        });
    }
    getPreview(key: string) {
        return `https://content.flavour.studio/${key}`;
    }
    getRoot() {
        return this.root;
    }
    getSoundBankKey(soundBank: string, config: any) {
        const soundBanks = config.resource_registry.base.soundbank_level?.vorbis || "soundbanks/vorbis";

        return `${this.root}/${soundBanks}/${soundBank}`;
    }
    load(): Promise<string | undefined> {
        if (! this.secret) return Promise.resolve(undefined);

        const command = new ListObjectsV2Command({
            Bucket: "content.flavour.studio",
            Prefix: `${this.root}`
        });
        const s3 = new S3Client({
            credentials: {
                secretAccessKey: this.secret.secret,
                accessKeyId: this.secret.key
            },
            region: "eu-west-2"
        });

        return s3.send(command).then(response => {
            if (! response.Contents) return undefined;
            response.Contents.filter(result => result.Key)
                .forEach(({Key, Size, LastModified}) => {
                    const key = Key!;
                    const path = key.split("/");
                    const fileName = path.pop() || "";
                    const pathName = path.join("/");
                    const folderName = path.pop() || "";
                    const parent = path.join("/");

                    this.addFolder(pathName);
                    this.files[key] = {
                        contentType: getMimeTypeFromExtension(key),
                        name: fileName,
                        parent: pathName,
                        size: Size || 0,
                        timestamp: LastModified?.getTime() || 0
                    };
                    this.folders[pathName].name = folderName;
                    this.folders[pathName].parent = parent;
                    this.folders[pathName].files.push(key);
            });
            return this.root;
        });
    }
    read(data: IContentData) {
        const decode = (data: any): {[key: string]: any} =>
            Object.fromEntries(Object.entries(data).map(([key, value]) =>
                [decodeURIComponent(key).replaceAll("%2E", "."), value]));

        this.files = decode(data.files);
        this.folders = decode(data.folders);
    }
    write() {
        const encode = (data: any) =>
            Object.fromEntries(Object.entries(data).map(([key, value]) =>
                [encodeURIComponent(key).replaceAll(".", "%2E"), value]));

        return {
            files: encode(this.files),
            folders: encode(this.folders)
        };
    }

    private addFolder(folder: string) {
        if (this.folders[folder] === undefined) {
            const path = folder.split("/");
            const folderName = path.pop() || "";
            this.folders[folder] = {
                name: folderName,
                parent: "",
                files: [],
                folders: []
            };
            if (path.length) {
                const parent = path.join("/");

                this.addFolder(parent);
                this.folders[parent].folders.push(folder);
            }
        }
    }
}
